import { createSelector } from "@reduxjs/toolkit";
import { useFormik } from "formik";
import { MoveLeft, MoveRight } from "lucide-react";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import {
  getJewelleryDiscountModel as onGetJewelleryDiscountModel,
  addJewelleryDiscount as onAddJewelleryDiscount,
  getJewelleryDiscount as onGetJewelleryDiscount,
  updateJewelleryDiscount as onUpdateJewelleryDiscount,
} from "slices/thunk";
import {
  setIsEditing,
  setSelectedProducts,
  resetSelectedProducts,
  setCurrentPage,
  setDiscountInfo,
  updateDiscountInfo,
} from "slices/discount/reducer";
import Select from "react-select";
import { useTabContext } from "context/TabContext";

interface DiscountInfoFormProps {
  eventData: any;
  // selectedProducts: any;
  isEdit: boolean;
  validation: any;
}

type DiscountType = {
  value: string;
  label: string;
};

const DiscountInfoForm: React.FC<DiscountInfoFormProps> = ({
  eventData,
  isEdit,
  validation
}) => {
  const dispatch = useDispatch<any>();
  const { changeTab } = useTabContext();

  // const [eventData, setEventData] = useState<any>();
  // const [isEdit, setIsEdit] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [discountType, setDiscountType] = useState<DiscountType>();

  const discountOptions = [
    { value: "", label: "Select Discount Type" },
    { value: "percentage", label: "Percentage" },
    { value: "fixed", label: "Fixed" },
  ];

  // const validation: any = useFormik({
  //   // enableReinitialize : use this flag when initial values needs to be changed
  //   enableReinitialize: true,
  //   initialValues: {
  //     type: (eventData && eventData.type) || "",
  //     value: (eventData && eventData.value) || "",
  //     startDate: (eventData && eventData.startDate) || "",
  //     endDate: (eventData && eventData.endDate) || "",
  //   },
  //   validationSchema: Yup.object({
  //     type: Yup.string().required("Please Enter Type"),
  //     value: Yup.string()
  //       .matches(/^\d+$/, "Value must be a valid number") // Allows only digits
  //       .required("Please Enter Value"),
  //     // value: Yup.number().required("Please Enter value"),
  //     startDate: Yup.date().required("Please Select date"),
  //     endDate: Yup.date().required("Please Select date"),
  //   }),

  //   onSubmit: (values: any) => {
  //     // save new Discount
  //     if (isEdit) {
  //       dispatch(
  //         updateDiscountInfo({
  //           id: eventData._id,
  //           fields: {
  //             type: values.type,
  //             startDate: moment(values.startDate).toISOString(),
  //             endDate: moment(values.endDate).toISOString(),
  //             value: Number(values.value),
  //           },
  //         })
  //       );

  //       // const updateData = {
  //       //     id: eventData._id,
  //       //     fields: {
  //       //         type: values.type,
  //       //         startDate: moment(values.startDate).toISOString(),
  //       //         endDate: moment(values.endDate).toISOString(),
  //       //         value: Number(values.value),
  //       //     },
  //       // };
  //     } else {
  //       dispatch(
  //         setDiscountInfo({
  //           type: values.type,
  //           value: Number(values.value),
  //           startDate: moment(values.startDate).toISOString(),
  //           endDate: moment(values.endDate).toISOString(),
  //         })
  //       );
  //     }
  //     changeTab("discountJewelleryProduct");
  //     // toggle();
  //   },
  // });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      // setEventData("");
      // setIsEdit(false);
      dispatch(resetSelectedProducts());
    } else {
      setShow(true);
      // setEventData("");
      validation.resetForm();
      dispatch(resetSelectedProducts());
    }
  }, [show, validation, dispatch]);

  useEffect(() => {
    // if (validation.values.endDate) {
    dispatch(
      setDiscountInfo({
        type: validation.values.type,
        value: validation.values.value,
        startDate: validation.values.startDate,
        endDate: validation.values.endDate,
      })
    );
    // }
  }, [dispatch]);

  const discounType = discountOptions.find(
    (option) => option.value === validation.values.type
  );

  return (
    <div>
      <form
        action="#!"
        onSubmit={(e: any) => {
          e.preventDefault();
          validation.handleSubmit();
          // validation.validateForm().then((errors: any) => {
          //   if (Object.keys(errors).length === 0) {
          //     validation.handleSubmit();
          //   } else {
          //     // Optional: If you want to show a custom error message
          //     console.log("Validation errors:", errors);
          //   }
          // });
          return false;
        }}
      >
        <div
          className="max-h-[calc(theme('height.screen')_-_270px)] overflow-y-auto"
          id="scrollableDiv"
        >
          <div className="grid grid-cols-1 gap-4 p-4 xl:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
            <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
              <label
                htmlFor="typeSelect"
                className="inline-block mb-2 text-base font-medium"
              >
                Type
              </label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={discountOptions}
                name="type"
                id="discountSelect"
                value={discounType || null} // Set the value from state
                // isDisabled={isLoading}
                onChange={(selectedDiscount: any) => {
                  setDiscountType(selectedDiscount);
                  validation.setFieldValue(
                    "type",
                    selectedDiscount?.value || ""
                  );
                }}
              />
              {validation.touched.type && validation.errors.type ? (
                <p className="text-red-400">{validation.errors.type}</p>
              ) : null}
            </div>
            <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
              <label
                htmlFor="jewelleryDiscountValue"
                className="inline-block mb-2 text-base font-medium"
              >
                Value
              </label>
              <input
                type="text"
                id="jewelleryDiscountValue"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Discount Value"
                name="value"
                onChange={validation.handleChange}
                value={validation.values.value || ""}
              />
              {validation.touched.value && validation.errors.value ? (
                <p className="text-red-400">{validation.errors.value}</p>
              ) : null}
            </div>
            <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
              <label
                htmlFor="startDateInput"
                className="inline-block mb-2 text-base font-medium"
              >
                Start Date
              </label>
              <Flatpickr
                id="startDateInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={{
                  dateFormat: "d M, Y",
                  minDate: moment().startOf('day').toDate(), // Disable past dates
                  // maxDate: validation.values.endDate // Disable dates beyond the selected endDate
                  //   ? moment.utc(validation.values.endDate).endOf("day").toDate()
                  //   : undefined,
                }}
                placeholder="Select date"
                name="startDate"
                onChange={(date: any) =>
                  validation.setFieldValue(
                    "startDate",
                    moment.utc(date[0]).toISOString()
                  )
                }
                value={validation.values.startDate || ""}
              />
              {validation.touched.startDate && validation.errors.startDate ? (
                <p className="text-red-400">{validation.errors.startDate}</p>
              ) : null}
            </div>
            <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
              <label
                htmlFor="endDateInput"
                className="inline-block mb-2 text-base font-medium"
              >
                End Date
              </label>
              <Flatpickr
                id="endDateInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={{
                  dateFormat: "d M, Y",
                  minDate: validation.values.startDate // Set minDate to the selected start date
                    ? moment.utc(validation.values.startDate).toDate()
                    : new Date(),
                }}
                placeholder="Select date"
                name="endDate"
                onChange={(date: any) =>
                  validation.setFieldValue(
                    "endDate",
                    moment.utc(date[0]).toISOString()
                  )
                }
                value={validation.values.endDate || ""}
              />
              {validation.touched.endDate && validation.errors.endDate ? (
                <p className="text-red-400">{validation.errors.endDate}</p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="bottom-0 bg-white p-4 pb-0 border-t dark:bg-zink-600 dark:border-zink-500">
          <div className="flex justify-end gap-2">
            {/* <button type="button" data-action="prev" className="text-slate-500 btn bg-slate-200 border-slate-200 hover:text-slate-600 hover:bg-slate-300 hover:border-slate-300 focus:text-slate-600 focus:bg-slate-300 focus:border-slate-300 focus:ring focus:ring-slate-100 active:text-slate-600 active:bg-slate-300 active:border-slate-300 active:ring active:ring-slate-100 dark:bg-zink-600 dark:hover:bg-zink-500 dark:border-zink-600 dark:hover:border-zink-500 dark:text-zink-200 dark:ring-zink-400/50"><MoveLeft className="inline-block h-4 mr-1 rtl:rotate-180" /> <span className="align-middle">Previous</span></button> */}
            <button
              type="submit"
              data-action="next"
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              <span className="align-middle">Next</span>{" "}
              <MoveRight className="inline-block h-4 ml-1 rtl:rotate-180" />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DiscountInfoForm;
